import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-solutions-section',
  templateUrl: './solutions-section.component.html',
  styleUrls: ['./solutions-section.component.css']
})
export class SolutionsSectionComponent implements OnInit {

  constructor(private route: ActivatedRoute) {
    this.route.fragment.subscribe((fragment) => {
      if(fragment) {
          setTimeout(()=>{
              document.getElementById(fragment)?.scrollIntoView({behavior: "smooth", block: "center" , inline: "nearest"});
          }, 500)
      }
    });
   }

  ngOnInit(): void {
  }

}
